
export const StarterPriceMap: {[environment:string]: string} = {
    development: 'price_1PC6wBKA8M9CmmC1zlV54Uy7',
    production: 'price_1PFyBMKA8M9CmmC10hlKyWzE',
}